export default __webpack_public_path__ + "static/media/erro.220fa893.png";